<script setup lang="ts">
const props = defineProps<{
  items: Array<{
    title: string
    color: string
    value: number
  }>
  formatter?: (value: number) => string
}>();

// Default formatter (just number formatting)
const formatValue = (value: number) => {
  if (props.formatter) {
    return props.formatter(value);
  }
  return new Intl.NumberFormat("tr-TR").format(value);
};

// Calculate max value for bar width percentage
const maxValue = computed(() => {
  const values = props.items.map(item => item.value);
  return values.length > 0 ? Math.max(...values) : 0;
});

// Get bar width percentage
const getBarWidth = (value: number) => {
  if (maxValue.value === 0) return 0;
  return (value / maxValue.value) * 100;
};
</script>

<template>
  <div class="space-y-2">
    <template v-if="items.length > 0">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="grid gap-2 items-center"
        style="grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);"
      >
        <!-- Sol sütun: Title -->
        <span class="text-xs text-neutral-600 dark:text-neutral-400 truncate">
          {{ item.title }}
        </span>

        <!-- Orta sütun: Progress bar -->
        <div class="relative h-1.5 bg-neutral-100 dark:bg-neutral-800 rounded-full overflow-hidden">
          <div
            class="absolute inset-y-0 left-0 rounded-full transition-all duration-300 ease-out"
            :style="{
              width: `${getBarWidth(item.value)}%`,
              backgroundColor: item.color
            }"
          />
        </div>

        <!-- Sağ sütun: Numerik değer -->
        <span class="text-xs font-semibold tabular-nums text-right">
          {{ formatValue(item.value) }}
        </span>
      </div>
    </template>
    <div v-else class="py-3 text-center text-xs text-neutral-400 dark:text-neutral-600">
      No data
    </div>
  </div>
</template>
